module.exports = __webpack_public_path__ + "static/media/splash1_2x.fa38acb7.jpg";